// Hook edycji komentarza do pozycji oferty.
// PUT /sales-crm/clients/:cid/offers/:oid/positions/:pid/comments/:commentId

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPutSalesCrmOfferPositionCommentPayload {
  comment?: string;
  isVisibleForClient?: boolean;
}

export interface IPutSalesCrmOfferPositionCommentVariables {
  commentId: number;
  payload: IPutSalesCrmOfferPositionCommentPayload;
}

type IResponse = ICommandResponseSuccess;

const putSalesCrmOfferPositionComment = (
  clientId: number,
  offerId: string,
  positionId: number,
  commentId: number,
  payload: IPutSalesCrmOfferPositionCommentPayload
): Promise<IResponse> =>
  axios.put(
    `/sales-crm/clients/${clientId}/offers/${offerId}/positions/${positionId}/comments/${commentId}`,
    payload
  );

export const usePutSalesCrmOfferPositionComment = (
  clientId: number,
  offerId: string,
  positionId: number,
  options?: UseMutationOptions<IResponse, IError, IPutSalesCrmOfferPositionCommentVariables>
) =>
  useMutation(
    ({ commentId, payload }: IPutSalesCrmOfferPositionCommentVariables) =>
      putSalesCrmOfferPositionComment(clientId, offerId, positionId, commentId, payload),
    options
  );
